export const html = "<p>Sleep under the stars in the Eghegis mountains.</p>\n";
export const leadHtml = "<p>Sleep under the stars in the Eghegis mountains.</p>\n";
export const bodyHtml = "";
export const metaText = "Sleep under the stars in the Eghegis mountains.";